$(document).ready(function() {
  let tabsTitleArray = document.querySelectorAll('.productAccordion__rowTitle');

  function toggleTab(event) {
    currentTabContainer = event.target.closest('.productAccordion__row');
    currentTabTitle = currentTabContainer.querySelector('.productAccordion__rowTitle');
    currentTabDescription = currentTabContainer.querySelector('.productAccordion__rowContent');
    const activeTabContainer = document.querySelector('.productAccordion__row--active');

    if (currentTabContainer.classList.contains('productAccordion__row--active')) {
      currentTabContainer.classList.remove('productAccordion__row--active');
      currentTabDescription.style.height = '0';
      currentTabTitle.style.top = 'unset';
    } else {
      if (activeTabContainer) {
        const activeTabTitle = activeTabContainer.querySelector('.productAccordion__rowTitle');
        const activeTabDescription = activeTabContainer.querySelector('.productAccordion__rowContent');

        activeTabContainer.classList.remove('productAccordion__row--active');
        activeTabDescription.style.height = '0';
        activeTabTitle.style.top = 'unset';
      }

      currentTabContainer.classList.add('productAccordion__row--active');
      currentTabDescription.style.height = `${currentTabDescription.scrollHeight}px`;
      
      const header = document.querySelector('.main-header');
      const headerHeight = header ? header.offsetHeight : 0;
      currentTabTitle.style.top = `${headerHeight}px`;
    }
  }

  tabsTitleArray.forEach((tab) => {
    tab.addEventListener('click', (event) => {
      toggleTab(event);
    })
  });
})
